import type { FC } from 'react';
import { Trans } from 'react-i18next';

interface CommunityTermsConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const CommunityTermsConsent: FC<CommunityTermsConsentProps> = ({ checked, onChange }) => {
  const termsLink = (
    // biome-ignore lint/a11y/useAnchorContent: <Trans> injects the localized link text at runtime.
    <a
      href="https://www.beehiiv.com/community-terms"
      target="_blank"
      rel="noreferrer"
      className="underline underline-offset-1 hover:opacity-80"
      onClick={(e) => e.stopPropagation()}
    />
  );

  return (
    <label className="flex w-full cursor-pointer items-start gap-2 text-left text-[13px] leading-5 text-black/60">
      <input
        type="checkbox"
        name="community_terms_accepted"
        value="true"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        required
        className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded border border-gray-300 accent-black"
      />
      <span>
        <Trans i18nKey="community.join.terms_consent" components={{ termsLink }} />
      </span>
    </label>
  );
};
